import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=303452d4&scoped=true&"
import script from "./newsletter.vue?vue&type=script&lang=js&"
export * from "./newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303452d4",
  null
  
)

export default component.exports